export class Instructor {
  id: string;
  displayName: string;
  givenName: string;
  familyName: string;
  checked = true;
  hasPhoto: boolean;
}
